<template>
  <div v-if="populationTemplate">
    <h1>Population template</h1>
    <v-btn :to="{name:'populationTemplates'}">
      <v-icon>chevron_left</v-icon>Population templates
    </v-btn>
    <v-text-field label="Id" v-model="populationTemplate.id" outline :disabled="true" />
    <v-text-field label="Heading" v-model="populationTemplate.heading" outline />
    <v-text-field label="Page name" v-model="populationTemplate.pagename" outline />
    <v-text-field label="Title" v-model="populationTemplate.title" outline />
    <v-textarea outline label="Description" v-model="populationTemplate.description" auto-grow />
    <v-textarea outline label="Body" v-model="populationTemplate.body" auto-grow />
    <v-btn @click="save">
      <v-icon>save</v-icon>Save
    </v-btn>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "PopulationTemplate",
  metaInfo() {
    return {
      title: "Population template",
      titleTemplate: "%s - SEO - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      populationTemplate: null
    };
  },
  methods: {
    fetchPopulationTemplate() {
      nbmlaw
        .get(`/cors/admin/extras/populationTemplates/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.populationTemplate = response.data;
        });
    },
    save() {
      if (this.$route.params.id) {
        this.updatePopulationTemplate();
      } else {
        this.createPopulationTemplate();
      }
    },
    updatePopulationTemplate() {
      nbmlaw
        .put(
          `/cors/admin/extras/populationTemplates/${this.$route.params.id}`,
          this.populationTemplate
        )
        .then(() => {
          // console.log(response.data);
          this.$router.push({ name: "populationTemplates" });
        });
    },
    createPopulationTemplate() {
      nbmlaw
        .post(`/cors/admin/extras/populationTemplates`, this.populationTemplate)
        .then(() => {
          // console.log(response.data);
          this.$router.push({ name: "populationTemplates" });
        });
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchPopulationTemplate();
        } else {
          this.populationTemplate = {
            id: null,
            heading: null,
            pagename: null,
            title: null,
            description: null,
            body: null
          };
        }
      }
    }
  }
};
</script>
